<template>
    <div v-if="!appconfig?.isAppUser">
        <aside v-if="!device.isMobile" class="filter-widget flex flex-col relative gap-3 pb-8 text-primary text-sm">
            <strong class="text-base text-paragraph">Mein expert</strong>
            <template v-if="loggedIn">
                <NuxtLink :to="'/shop/mein-expert/uebersicht'">Übersicht</NuxtLink>
                <NuxtLink :to="'/shop/mein-expert/persoenliche-daten'">Persönliche Daten</NuxtLink>
                <NuxtLink :to="'/shop/mein-expert/bestellungen'">Meine Bestellungen</NuxtLink>
                <NuxtLink :to="'/shop/wishlist'">Mein Merkzettel</NuxtLink>
                <template v-if="fullPaybackFeature">
                    <NuxtLink :to="'/shop/mein-expert/payback'">Mein PAYBACK</NuxtLink>
                </template>
            </template>
            <template v-if="!loggedIn">
                <div class="cursor-pointer" @click="login('keycloak', { prompt: 'create' })">
                    <strong>Jetzt Registrieren</strong>
                </div>
            </template>
        </aside>
    </div>
</template>

<script setup lang="ts">
    const { login } = useOidcAuth()
    const appconfig = useAppConfig();
    const device = useDevice();
    const loggedIn = useCurrentLoggedInState().value;
    const currentStore = useCurrentStore(); 
    const featureStatePayback = computed(() => useFeatureState('exsi-1556') && currentStore.value.paybackStore);
    const fullPaybackFeature = computed(() => featureStatePayback.value && (useFeatureValue('exsi-1556').value?.name == 'full'));
</script>
<style lang="postcss" scoped>
    a {
        @apply flex items-center gap-1;
    }
</style>